import Vue from 'vue'
import App from './App'
import router from './router'
import Vuex from 'vuex'
import axios from 'axios'
import stort from './store'
import { Swipe, SwipeItem,Lazyload, SwipeCell,Row, Col,Card,List,Toast} from 'vant';
import VueWechatTitle from 'vue-wechat-title'
import './assets/css/markdown/dark.css' //引入代码高亮的css
import hljs from 'highlight.js'
import './assets/css/common.css'
import showdown from 'showdown'

Vue.use(VueWechatTitle)
Vue.config.productionTip = false
Vue.use(Vuex)
Vue.use(Swipe).use(SwipeItem).use(SwipeCell).use(Lazyload).use(Row).use(Col).use(Card).use(List).use(Toast);
axios.defaults.baseURL = dev()
Vue.prototype.$http = axios
/* eslint-disable no-new */
Vue.prototype.md2html = (md)=> {
  let converter = new showdown.Converter()
  let text = md.toString()
  let html = converter.makeHtml(text)
  return html
}
new Vue({
  el: '#app',
  router,
  stort,
  axios,
  components: { App },
  template: '<App/>'
})

router.beforeEach((to,from,next) => {
  if (to.meta.title) { // 判断是否有标题
    document.title = to.meta.title ? to.meta.title : defaultTitle;
  }
  next();
})

Vue.prototype.mywindow = window
Vue.directive('highlight', (el) => {
  let blocks = el.querySelectorAll('pre code')
      blocks.forEach((block) => {
          hljs.highlightBlock(block)
      })
  })
  function dev () {
    if (process.env.NODE_ENV !== 'development') {
      return 'http://' + document.location.host + '/api'
    } else {
      return 'http://10.0.12.220:8088/api'
    }
  }



// WEBPACK FOOTER //
// ./src/main.js